<template>
  <div class="container">
    <div class="row p-1 mt-3 bg-white">
      <div class="row p-2">
        <h4 style="margin-left: 20px;"><ExclamationCircleOutlined />&nbsp;&nbsp;關於本系統</h4>
        <a-divider />
        <a-descriptions style="margin-left: 9pt;" :column="1" :size="size" bordered layout="vertical">
          <a-descriptions-item label="系統說明" :labelStyle="itemLabelStyle">
            本系統主要用於管理線上健檢問卷，
            <br />
            並提供相關圖表與多種問卷結果格式匯出功能。
          </a-descriptions-item>
          <a-descriptions-item label="使用說明" :labelStyle="itemLabelStyle">
            <a-button type="primary" @click="downloadUserManual" disabled="true">
              <DownloadOutlined />&nbsp;下載使用說明
            </a-button>
          </a-descriptions-item>
          <a-descriptions-item label="開發維運商" :labelStyle="itemLabelStyle">三原科技股份有限公司</a-descriptions-item>
          <a-descriptions-item label="公司統編" :labelStyle="itemLabelStyle">83769040</a-descriptions-item>
          <a-descriptions-item label="聯絡電話" :labelStyle="itemLabelStyle">0972-500-080</a-descriptions-item>
          <a-descriptions-item label="聯絡信箱" :labelStyle="itemLabelStyle">frankie@rgbtechgroup.com</a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ExclamationCircleOutlined, DownloadOutlined } from "@ant-design/icons-vue";
import { ref } from 'vue';
const size = ref('middle');
const itemLabelStyle = {
  color: 'blue'
}

const downloadUserManual = () => {
  // common.downloadFile(config.downloadMgmtUserManual, "健檢管理系統使用手冊.pdf");
}
</script>
<style scoped>
  button,
  span {
    display: inline-flex;
    align-items: center;
  }
  .input-text-style {
    width: 200px;
  }
</style>